import React from "react";

const FolderIcon = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="white"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1631_62" x="0" y="0" width="25" height="24">
        <rect x="0.822754" width="23.6962" height="24" fill="white" />
      </mask>
      <g mask="url(#mask0_1631_62)">
        <path
          d="M12.0252 16.6538H19.2403V16.2961C19.2403 15.6295 18.9147 15.1057 18.2634 14.725C17.6122 14.3442 16.7353 14.1538 15.6328 14.1538C14.5302 14.1538 13.6533 14.3442 13.0021 14.725C12.3508 15.1057 12.0252 15.6295 12.0252 16.2961V16.6538ZM15.6328 12.8461C16.1125 12.8461 16.5204 12.6759 16.8565 12.3356C17.1926 11.9952 17.3606 11.582 17.3606 11.0961C17.3606 10.6102 17.1926 10.1971 16.8565 9.85673C16.5204 9.51634 16.1125 9.34615 15.6328 9.34615C15.153 9.34615 14.7451 9.51634 14.4091 9.85673C14.073 10.1971 13.9049 10.6102 13.9049 11.0961C13.9049 11.582 14.073 11.9952 14.4091 12.3356C14.7451 12.6759 15.153 12.8461 15.6328 12.8461ZM5.07583 19.5C4.57709 19.5 4.15494 19.325 3.80937 18.975C3.4638 18.625 3.29102 18.1974 3.29102 17.6923V6.3077C3.29102 5.80257 3.4638 5.375 3.80937 5.025C4.15494 4.675 4.57709 4.5 5.07583 4.5H10.4967L12.4713 6.5H20.2656C20.7644 6.5 21.1865 6.675 21.5321 7.025C21.8777 7.375 22.0505 7.80257 22.0505 8.3077V17.6923C22.0505 18.1974 21.8777 18.625 21.5321 18.975C21.1865 19.325 20.7644 19.5 20.2656 19.5H5.07583ZM5.07583 18H20.2656C20.3543 18 20.4271 17.9711 20.484 17.9134C20.541 17.8557 20.5695 17.782 20.5695 17.6923V8.3077C20.5695 8.21795 20.541 8.14422 20.484 8.08652C20.4271 8.02883 20.3543 7.99998 20.2656 7.99998H11.8657L9.891 5.99998H5.07583C4.98722 5.99998 4.91443 6.02882 4.85746 6.08652C4.80049 6.14423 4.772 6.21795 4.772 6.3077V17.6923C4.772 17.782 4.80049 17.8557 4.85746 17.9134C4.91443 17.9711 4.98722 18 5.07583 18Z"
          fill="#white"
        />
      </g>
    </svg>
  );
};

export default FolderIcon;
